import { Box, CircularProgress, Typography } from "@mui/material";

export default function FullPageLoader({ open, text = "Loading..." }) {
  if (!open) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        bgcolor: "rgba(255, 255, 255, 0.75)",
        zIndex: 2000, // higher than dialogs
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backdropFilter: "blur(2px)",
        cursor: "wait",
      }}
    >
      <CircularProgress size={70} thickness={4} />
      <Typography variant="h6" sx={{ mt: 2, color: "#1976d2" }}>
        {text}
      </Typography>
    </Box>
  );
}
